export enum TierConfigurationPermissions {
  VIEW_TIER_CONFIGURATION = "view_tier_configuration",
  CREATE_TIER_CONFIGURATION = "create_tier_configuration",
  UPDATE_TIER_CONFIGURATION = "update_tier_configuration",
  DELETE_TIER_CONFIGURATION = "delete_tier_configuration",
  ARCHIVE_TIER_CONFIGURATION = "archive_tier_configuration",
}

export const TierConfigurationPermissionsText: Record<
  TierConfigurationPermissions,
  string
> = {
  [TierConfigurationPermissions.VIEW_TIER_CONFIGURATION]:
    "View Tier Configuration",
  [TierConfigurationPermissions.CREATE_TIER_CONFIGURATION]:
    "Create Tier Configuration",
  [TierConfigurationPermissions.UPDATE_TIER_CONFIGURATION]:
    "Update Tier Configuration",
  [TierConfigurationPermissions.DELETE_TIER_CONFIGURATION]:
    "Delete Tier Configuration",
  [TierConfigurationPermissions.ARCHIVE_TIER_CONFIGURATION]:
    "Archive Tier Configuration",
};
